import React from "react"
import { useBreakpointIndex } from "@theme-ui/match-media"
import { Link } from "theme-ui"
import * as componentStyle from "assets/css/components.module.css"
import { IoLogoWhatsapp } from "@react-icons/all-files/io/IoLogoWhatsapp"
import { MdEmail } from "@react-icons/all-files/md/MdEmail"
import { IoCallSharp } from "@react-icons/all-files/io5/IoCallSharp"

const btnStyle = {
    justifyContent: "center",
    marginRight: 8 + "px",
    display: "flex",
    alignItems: "center",
    marginBottom: 8 + "px",
}

const CTAButton = ({ data }) => {
    const breakpointIndex = useBreakpointIndex()
    const buttonText = data.buttonText.trim()
    const buttonIcon = data.buttonIcon

    return (
        <div>
            <Link
                variant="buttonSquare"
                className={buttonText === "Call Now" ? "" : ""}
                href={data.buttonLink}
                target="_blank"
                rel="noreferrer"
                sx={{
                    ...btnStyle,
                    width: breakpointIndex >= 3 ? "170px" : "auto",
                    padding:
                        breakpointIndex < 2
                            ? "8px 24px !important"
                            : "8px 32px",
                }}
            >
                {!buttonIcon && buttonText.toLowerCase() === "call now" ? (
                    <span className={componentStyle.reactIcons}>
                        <IoCallSharp />
                    </span>
                ) : !buttonIcon && buttonText.toLowerCase() === "whatsapp" ? (
                    <span className={componentStyle.reactIcons}>
                        <IoLogoWhatsapp />
                    </span>
                ) : !buttonIcon && buttonText.toLowerCase() === "email us" ? (
                    <span className={componentStyle.reactIcons}>
                        <MdEmail />
                    </span>
                ) : buttonIcon ? (
                    <img
                        src={buttonIcon.publicURL}
                        width="20"
                        height="20"
                        alt={buttonText}
                    />
                ) : null}
                {/* {breakpointIndex >= 3 ? buttonText : ""} */}
                {buttonText}
            </Link>
            {data.buttonType === "Custom" ? data.externalScripts : null}
        </div>
    )
}

export default CTAButton
